'use strict';

exports.RefinementsUIVersions = {
	Updated: 'Updated',
	Legacy: 'Legacy'
}